<template>
<b-skeleton-wrapper :loading="loading">
    
       <b-card>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas viverra nunc sapien,
        non rhoncus elit tincidunt vitae. Vestibulum maximus, ligula eu feugiat molestie,
        massa diam imperdiet odio, vitae viverra ligula est id nisi. Aliquam ut molestie est.
        Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac
        turpis egestas. Phasellus at consequat dui. Aenean tristique sagittis quam,
        sit amet sollicitudin neque sodales in.
      </b-card>
    <b-container>
            <b-row>
                <b-col>
                    <b-card title="Perfil" class="mb-5">
                        <hr>
                        <b-form>
                            <!--fila 1-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-1"
                                        label="Nombre"
                                        label-for="input-1"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-2"
                                    label="Segundo nombre"
                                    label-for="input-2"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 1-->
                            <!--fila 2-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-3"
                                        label="Apellido paterno"
                                        label-for="input-3"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-4"
                                    label="Apellido materno"
                                    label-for="input-4"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 2-->
                            <!--fila 3-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-5"
                                        label="Cédula/Pasaporte"
                                        label-for="input-5"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-6"
                                    label="País"
                                    label-for="input-6"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-7"
                                    label="Fecha de Nacimiento"
                                    label-for="input-7"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 3-->
                            <!--fila 4-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-8"
                                        label="Licencia"
                                        label-for="input-8"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-9"
                                    label="País"
                                    label-for="input-9"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-10"
                                    label="Fecha de Vencimiento"
                                    label-for="input-10"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 4-->
                            <!--fila 5-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-11"
                                        label="Lugar de trabajo"
                                        label-for="input-11"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-12"
                                    label="Teléfono (trabajo)"
                                    label-for="input-12"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-13"
                                    label="Celular (trabajo)"
                                    label-for="input-13"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 5-->
                            <h4>Residencia</h4>
                            <hr>
                            <!--fila 6-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-14"
                                        label="País"
                                        label-for="input-14"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-15"
                                    label="Ciudad"
                                    label-for="input-15"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-16"
                                    label="Barrio"
                                    label-for="input-16"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 6-->
                            <!--fila 7-->
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="input-group-17"
                                        label="Calle"
                                        label-for="input-17"
                                        description="">
                                        <b-skeleton type="input"></b-skeleton>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-18"
                                    label="Casa"
                                    label-for="input-18"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                    id="input-group-19"
                                    label="Teléfono"
                                    label-for="input-19"
                                    description="">
                                    <b-skeleton type="input"></b-skeleton>
                                </b-form-group>
                                </b-col>
                            </b-row>
                            <!--fila 7-->
                            <b-row>
                                <b-col>
                                    <b-skeleton type="button"></b-skeleton>
                                </b-col>
                            </b-row>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        </b-skeleton-wrapper>
</template>

<script>
    export default {
        data() {
            return {
                loading: false
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>